module.exports = __webpack_public_path__ + "static/img/bird-home-dark.c5418b66.svg";